import { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button/Button";
import { ACCEPTED_CHROME_VERSION } from "../../constants";

class BrowserCompatibility extends Component {
    constructor(props) {
        super(props);
        var browser = this.get_browser();
        var isSupported = this.isSupported(browser);

        this.state = {
            notSupported: !isSupported,
            opened: true,
            browser,
            title: this.getTitle(browser),
        };
    }

    getTitle(browser) {
        let title;

        if (browser.name === "Chrome" && browser.version < ACCEPTED_CHROME_VERSION) {
            title = "Veuillez mettre à jour Chrome";
        } else if (browser.name === "Safari") title = "";
        else {
            title = "Veuillez utiliser le navigateur Chrome";
        }

        return title;
    }

    isSupported(browser) {
        var supported = false;
        if (browser.name === "Chrome" && browser.version >= ACCEPTED_CHROME_VERSION) {
            supported = true;
        } else if (browser.name === "Safari") {
            //On laisse tranquille les managers..
            supported = true;
        }

        return supported;
    }

    /* eslint-disable */
    get_browser() {
        var ua = navigator.userAgent,
            tem,
            M = ua.match(/(opera|chrome|safari|SamsungBrowser|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: "IE", version: tem[1] || "" };
        }
        if (M[1] === "Chrome") {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem != null) {
                return { name: "Opera", version: tem[1] };
            }
        }
        if (window.navigator.userAgent.indexOf("Edge") > -1) {
            tem = ua.match(/\Edge\/(\d+)/);
            if (tem != null) {
                return { name: "Edge", version: tem[1] };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: +M[1],
        };
    }

    close() {
        this.setState({
            opened: false,
        });
    }

    render() {
        if (!this.state.notSupported) return null;

        return (
            <Dialog
                fullWidth
                className={{ paper: "without-side-margin" }}
                open={this.state.opened}
                onClose={this.close.bind(this)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">{this.state.title}</DialogTitle>
                <DialogContent>
                    <span>
                        {"Il semble que votre navigateur ne soit pas à jour ou que vous " +
                            "utilisiez un navigateur autre que Google Chrome. "}
                    </span>
                    <br />
                    <span>
                        {"MyOpen a été conçu pour fonctionner sous Chrome, " +
                            "le fonctionnement sur un autre navigateur n'est pas assuré."}
                    </span>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.close.bind(this)} className="button" color="primary">
                        {"Ok"}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default BrowserCompatibility;
